module.exports = __webpack_public_path__ + "img/03.9e3f1ceb.gif";